// extracted by mini-css-extract-plugin
export var image = "ColumnItem-module--image--ff8f4";
export var richtext = "ColumnItem-module--richtext--e404a";